// extracted by mini-css-extract-plugin
export var footer = "_px-0";
export var inherit = "_px-1";
export var input = "_px-2";
export var modalContent = "_px-3";
export var quillEditor = "_px-4";
export var subtitle = "_px-5";